// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

// @generated by protobuf-ts 2.9.6 with parameter force_server_none,optimize_code_size,ts_nocheck
// @generated from protobuf file "sui/forking/v1alpha/forking_service.proto" (package "sui.forking.v1alpha", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
//
import { ServiceType } from '@protobuf-ts/runtime-rpc';
import { MessageType } from '@protobuf-ts/runtime';
/**
 * @generated from protobuf message sui.forking.v1alpha.AdvanceClockRequest
 */
export interface AdvanceClockRequest {
	/**
	 * Duration in milliseconds to advance the clock. Defaults to 1 if unset.
	 *
	 * @generated from protobuf field: optional uint64 duration_ms = 1;
	 */
	durationMs?: bigint;
}
/**
 * @generated from protobuf message sui.forking.v1alpha.AdvanceClockResponse
 */
export interface AdvanceClockResponse {
	/**
	 * Clock timestamp after advancing (milliseconds since Unix epoch).
	 *
	 * @generated from protobuf field: uint64 timestamp_ms = 1;
	 */
	timestampMs: bigint;
	/**
	 * Digest of the ConsensusCommitPrologue transaction that advanced the clock.
	 *
	 * @generated from protobuf field: string tx_digest = 2;
	 */
	txDigest: string;
}
/**
 * @generated from protobuf message sui.forking.v1alpha.AdvanceCheckpointRequest
 */
export interface AdvanceCheckpointRequest {}
/**
 * @generated from protobuf message sui.forking.v1alpha.AdvanceCheckpointResponse
 */
export interface AdvanceCheckpointResponse {
	/**
	 * Sequence number of the newly created checkpoint.
	 *
	 * @generated from protobuf field: uint64 checkpoint_sequence_number = 1;
	 */
	checkpointSequenceNumber: bigint;
	/**
	 * Timestamp embedded in the checkpoint (milliseconds since Unix epoch).
	 *
	 * @generated from protobuf field: uint64 timestamp_ms = 2;
	 */
	timestampMs: bigint;
}
/**
 * @generated from protobuf message sui.forking.v1alpha.GetStatusRequest
 */
export interface GetStatusRequest {}
/**
 * @generated from protobuf message sui.forking.v1alpha.GetStatusResponse
 */
export interface GetStatusResponse {
	/**
	 * Current epoch of the forked network.
	 *
	 * @generated from protobuf field: uint64 epoch = 1;
	 */
	epoch: bigint;
	/**
	 * Latest checkpoint sequence number.
	 *
	 * @generated from protobuf field: uint64 checkpoint_sequence_number = 2;
	 */
	checkpointSequenceNumber: bigint;
	/**
	 * Current clock timestamp (milliseconds since Unix epoch).
	 *
	 * @generated from protobuf field: uint64 timestamp_ms = 3;
	 */
	timestampMs: bigint;
	/**
	 * The upstream checkpoint at which the fork was created.
	 *
	 * @generated from protobuf field: uint64 forked_at_checkpoint = 4;
	 */
	forkedAtCheckpoint: bigint;
}
// @generated message type with reflection information, may provide speed optimized methods
class AdvanceClockRequest$Type extends MessageType<AdvanceClockRequest> {
	constructor() {
		super('sui.forking.v1alpha.AdvanceClockRequest', [
			{
				no: 1,
				name: 'duration_ms',
				kind: 'scalar',
				opt: true,
				T: 4 /*ScalarType.UINT64*/,
				L: 0 /*LongType.BIGINT*/,
			},
		]);
	}
}
/**
 * @generated MessageType for protobuf message sui.forking.v1alpha.AdvanceClockRequest
 */
export const AdvanceClockRequest = new AdvanceClockRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdvanceClockResponse$Type extends MessageType<AdvanceClockResponse> {
	constructor() {
		super('sui.forking.v1alpha.AdvanceClockResponse', [
			{
				no: 1,
				name: 'timestamp_ms',
				kind: 'scalar',
				T: 4 /*ScalarType.UINT64*/,
				L: 0 /*LongType.BIGINT*/,
			},
			{ no: 2, name: 'tx_digest', kind: 'scalar', T: 9 /*ScalarType.STRING*/ },
		]);
	}
}
/**
 * @generated MessageType for protobuf message sui.forking.v1alpha.AdvanceClockResponse
 */
export const AdvanceClockResponse = new AdvanceClockResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdvanceCheckpointRequest$Type extends MessageType<AdvanceCheckpointRequest> {
	constructor() {
		super('sui.forking.v1alpha.AdvanceCheckpointRequest', []);
	}
}
/**
 * @generated MessageType for protobuf message sui.forking.v1alpha.AdvanceCheckpointRequest
 */
export const AdvanceCheckpointRequest = new AdvanceCheckpointRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdvanceCheckpointResponse$Type extends MessageType<AdvanceCheckpointResponse> {
	constructor() {
		super('sui.forking.v1alpha.AdvanceCheckpointResponse', [
			{
				no: 1,
				name: 'checkpoint_sequence_number',
				kind: 'scalar',
				T: 4 /*ScalarType.UINT64*/,
				L: 0 /*LongType.BIGINT*/,
			},
			{
				no: 2,
				name: 'timestamp_ms',
				kind: 'scalar',
				T: 4 /*ScalarType.UINT64*/,
				L: 0 /*LongType.BIGINT*/,
			},
		]);
	}
}
/**
 * @generated MessageType for protobuf message sui.forking.v1alpha.AdvanceCheckpointResponse
 */
export const AdvanceCheckpointResponse = new AdvanceCheckpointResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatusRequest$Type extends MessageType<GetStatusRequest> {
	constructor() {
		super('sui.forking.v1alpha.GetStatusRequest', []);
	}
}
/**
 * @generated MessageType for protobuf message sui.forking.v1alpha.GetStatusRequest
 */
export const GetStatusRequest = new GetStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStatusResponse$Type extends MessageType<GetStatusResponse> {
	constructor() {
		super('sui.forking.v1alpha.GetStatusResponse', [
			{
				no: 1,
				name: 'epoch',
				kind: 'scalar',
				T: 4 /*ScalarType.UINT64*/,
				L: 0 /*LongType.BIGINT*/,
			},
			{
				no: 2,
				name: 'checkpoint_sequence_number',
				kind: 'scalar',
				T: 4 /*ScalarType.UINT64*/,
				L: 0 /*LongType.BIGINT*/,
			},
			{
				no: 3,
				name: 'timestamp_ms',
				kind: 'scalar',
				T: 4 /*ScalarType.UINT64*/,
				L: 0 /*LongType.BIGINT*/,
			},
			{
				no: 4,
				name: 'forked_at_checkpoint',
				kind: 'scalar',
				T: 4 /*ScalarType.UINT64*/,
				L: 0 /*LongType.BIGINT*/,
			},
		]);
	}
}
/**
 * @generated MessageType for protobuf message sui.forking.v1alpha.GetStatusResponse
 */
export const GetStatusResponse = new GetStatusResponse$Type();
/**
 * @generated ServiceType for protobuf service sui.forking.v1alpha.ForkingService
 */
export const ForkingService = new ServiceType('sui.forking.v1alpha.ForkingService', [
	{ name: 'AdvanceClock', options: {}, I: AdvanceClockRequest, O: AdvanceClockResponse },
	{
		name: 'AdvanceCheckpoint',
		options: {},
		I: AdvanceCheckpointRequest,
		O: AdvanceCheckpointResponse,
	},
	{ name: 'GetStatus', options: {}, I: GetStatusRequest, O: GetStatusResponse },
]);
